import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import Pagination from "../components/react/Pagination";
import Button from "../components/react/Button";
import Loader from "../components/react/Loader";
import TeasePost from "../components/react/TeasePost";

const initialCategory = 0;
const initialPage = 0;
const initialPages = 0;

const url = siteData.restUrl;

const App = () => {
	const perPage = 12;

	const [containerHeight, setContainerHeight] = useState([]);
	const [categories, setCategories] = useState([]);
	const [category, setCategory] = useState(initialCategory);
	const [page, setPage] = useState(initialPage);
	const [pages, setPages] = useState(initialPages);
	const [posts, setPosts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [defaultThumbnail, setDefaultThumbnail] = useState();

	const container = useRef(null);

	const scrollToTopOfContainer = () => {
		container.current.scrollIntoView({
			alignToTop: true,
		});
	};

	const getTitle = () => {
		let title = "Latest News";

		if (category) {
			const populated = categories.find((c) => c.id === category);

			title =
				populated && populated.acf.latest_title
					? populated.acf.latest_title
					: title;
		}

		return title;
	};

	useEffect(() => {
		setLoading(true);
		const source = axios.CancelToken.source();

		const getPosts = async () => {
			const params = new URLSearchParams();

			params.append("_embed", true);
			params.append("per_page", perPage);
			params.append("offset", page * perPage);

			if (category) {
				params.append("categories", category);
			}

			const postRes = await axios.get(`${url}wp/v2/posts`, {
				params,
				cancelToken: source.token,
			});

			for (const post of postRes.data) {
				if (!post?.featured_media) {
					post.thumbnail = defaultThumbnail;
					continue;
				}

				const img = post._embedded["wp:featuredmedia"][0].media_details;

				let sizes = [
					{
						url: img.sizes.thumbnail.source_url,
						size: "1x",
					},
				];

				if (img.sizes?.thumbnail_2x) {
					sizes = [
						...sizes,
						{
							url: img.sizes.thumbnail_2x.source_url,
							size: "2x",
						},
					];
				}

				post.thumbnail = {
					url: img.sizes.thumbnail.source_url,
					alt: img.alt_text,
					sizes,
				};
			}

			setPosts(postRes.data);
			setPages(parseInt(postRes.headers["x-wp-totalpages"]));
			setLoading(false);
		};

		getPosts();

		return () => {
			source.cancel();
		};
	}, [category, page]);

	useEffect(() => {
		const source = axios.CancelToken.source();

		const getCategoryOptions = async () => {
			const options_res = await axios.get(
				`${url}acf/v3/options/global_options`
			);

			setDefaultThumbnail({
				url: options_res?.data?.acf?.news_placeholder?.url,
				alt: "",
				sizes: [],
			});

			const res = await axios.get(`${url}wp/v2/categories`, {
				cancelToken: source.token,
			});

			setCategories(res.data.filter((c) => c.acf.is_filterable));
		};

		getCategoryOptions();

		return () => {
			source.cancel();
		};
	}, []);

	return (
		<div
			ref={container}
			className="container"
			style={{ height: containerHeight, position: "relative" }}
		>
			<div className="mb-3 row">
				<div className="col-12">
					<h2 className="h-green">Select By Category</h2>
				</div>
				<div className="flex-wrap col-12 d-flex justify-content-between">
					<Button
						active={!category}
						text="News"
						color="yellow"
						onClick={() => {
							setPage(initialPage);
							setCategory();
						}}
					/>
					{categories.map((cat) => (
						<Button
							key={cat.id}
							text={cat.name}
							color={cat.acf.button_color}
							active={category === cat.id}
							onClick={() => {
								setPage(initialPage);
								setCategory(cat.id);
							}}
						/>
					))}
				</div>
			</div>
			<div className="mb-3 row">
				<div className="col-12">
					<h2 className="mb-3 h-yellow">{getTitle()}</h2>
				</div>

				{!!loading ? (
					<div className="col-12">
						<p>Loading articles...</p>
					</div>
				) : (
					<>
						{!posts.length && (
							<div className="col-12">
								<p>No posts found.</p>
							</div>
						)}

						{posts.map((post, idx) => (
							<TeasePost key={post.id} post={post} idx={idx} />
						))}
					</>
				)}
			</div>
			{!loading && (
				<div className="row">
					<div className="col-auto mx-auto">
						{pages > 1 && (
							<Pagination
								page={page}
								pageCount={pages}
								initialPage={initialPage}
								setPage={(page) => {
									scrollToTopOfContainer();
									setPage(page);
								}}
							/>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

const mountPoint = document.querySelector(".js-mount-news");

if (mountPoint) {
	ReactDOM.render(<App />, mountPoint);
}
